import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { WeightFormatPipe } from 'app/pipes/weight-format.pipe';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';
import { UnitMeasureDisplayComponent } from 'app/shared/components/unit-measure-display/unit-measure-display.component';

@Component({
  selector: 'app-order-details-table',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatSidenav,
    MatSidenavContainer,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    WeightFormatPipe,
    CompanyCurrencyPipe,
    UnitMeasureDisplayComponent
  ],
  templateUrl: './order-details-table.component.html',
  styleUrl: './order-details-table.component.scss',
  animations: [
    trigger("expandCollapse", [
      state(
        "void",
        style({
          height: "0px",
          opacity: 0,
        }),
      ),
      state(
        "*",
        style({
          height: "*",
          opacity: 1,
        }),
      ),
      transition("void <=> *", animate("300ms ease-in-out")),
      transition("* => void", animate("300ms ease-in-out")),
    ]),
  ],
})
export class OrderDetailsTableComponent implements OnInit {
  
  @Input() detailData: OrderDetailAttributes[] | null = null;
  @Input() relatedOrders: OrderDetailAttributes[] | null = null;
  @Input() UMPActive:boolean = false;
  
  displayedColumns: string[] = ['material', 'price', 'soldQuantity', 'stockConfirmedERP', 'unificationCode'];
  dataSource = new MatTableDataSource<OrderDetailAttributes>([]);
  areRelatedOrderExisted = false;
  
  ngOnInit(): void {
    if (this.detailData) {
      this.dataSource.data = this.detailData;
    }

    if(this.relatedOrders) {
      this.areRelatedOrderExisted = true;
      this.displayedColumns.unshift('view');
    }
  }

  changeSort(event: any) {
  }

}